import { render, staticRenderFns } from "./ObiAlert.vue?vue&type=template&id=6f6068ca&scoped=true&"
import script from "./ObiAlert.vue?vue&type=script&lang=js&"
export * from "./ObiAlert.vue?vue&type=script&lang=js&"
import style0 from "./ObiAlert.vue?vue&type=style&index=0&id=6f6068ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6068ca",
  null
  
)

export default component.exports